import { forwardRef, Suspense } from 'react';
import { GreySection } from '../../../Common/Section/GreySection';
import { SectionHeader } from '../../../partner-pages/utils/section-header';
import { DEFAULT_NAV_PROPS, ITR_SECTION } from '../../static/types';
import dynamic from 'next/dynamic';

const FlipCardWrapper = dynamic(
  () => import('../../../CardFlip').then((mod) => mod.FlipCardWrapper),
  { suspense: true }
);

interface FILE_ITR_PROPS extends DEFAULT_NAV_PROPS {
  data: ITR_SECTION;
}

export const FileItrSection: React.FC<FILE_ITR_PROPS> = forwardRef(
  ({ id, data, name, isVariant }, ref: React.ForwardedRef<HTMLDivElement>) => {
    return (
      <div ref={ref} key={name} id={id}>
        <GreySection>
          <SectionHeader
            heading={data.title}
            description={data.desc}
            align="center"
            className=" text-s-46 sm:text-s-24 md:text-s-28 lg:text-s-32"
            descriptionClassName="sm:text-s-14 md:text-base lg:text-s-20 xl:text-s-24 text-center sm:px-10"
          />
          <Suspense fallback={<div>Loading Cards...</div>}>
            <FlipCardWrapper
              cardData={data.cards}
              trackLabel={`file_with_cleartax_fold`}
              isVariant={isVariant}
            />
          </Suspense>
        </GreySection>
      </div>
    );
  }
);

FileItrSection.displayName = 'FileItrSection';
